var _path, _g, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12003_3400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12003_3400",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12003_3400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5191 14.9064L14.8113 14.6142C15.1503 14.2752 15.6999 14.2752 16.0389 14.6142L17.2666 15.8418C17.6056 16.1809 17.6056 16.7304 17.2666 17.0695L13.4973 20.8387C12.0562 22.2798 10.1681 23 8.27964 23C6.39116 23 4.50268 22.2798 3.06194 20.8387C0.220846 17.998 0.180457 13.4175 2.94077 10.527",
    stroke: "#6F767E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 10.9218L6.83107 6.63396C7.1701 6.29494 7.71967 6.29494 8.05869 6.63396L9.28631 7.86158C9.62533 8.2006 9.62533 8.75017 9.28631 9.0892L5.51709 12.8588C3.98482 14.3907 3.99428 16.8897 5.54459 18.4104C7.07986 19.9165 9.55615 19.8688 11.0768 18.3481L14.5781 14.8218",
    stroke: "#6F767E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 16.885L14.9954 19.3403",
    stroke: "#6F767E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55957 8.90548L7.01493 11.3608",
    stroke: "#6F767E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1686 2.16719C14.1686 2.93431 13.5467 3.55615 12.7796 3.55615C12.0125 3.55615 11.3906 2.93431 11.3906 2.16719C11.3906 1.40007 12.0125 0.778223 12.7796 0.778223C13.5467 0.778223 14.1686 1.40007 14.1686 2.16719Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7326 5.8999H10.8261C10.5864 5.8999 10.3921 5.70555 10.3921 5.46583V4.94496C10.3921 4.17789 11.0139 3.556 11.7811 3.556H13.7777C14.5448 3.556 15.1667 4.17789 15.1667 4.94496V5.46583C15.1667 5.70555 14.9723 5.8999 14.7326 5.8999Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1759 10.5695C22.1759 11.3367 21.554 11.9585 20.7869 11.9585C20.0198 11.9585 19.3979 11.3367 19.3979 10.5695C19.3979 9.80241 20.0198 9.18057 20.7869 9.18057C21.554 9.18057 22.1759 9.80241 22.1759 10.5695Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7404 14.3022H18.8339C18.5942 14.3022 18.3999 14.1079 18.3999 13.8682V13.3473C18.3999 12.5802 19.0217 11.9583 19.7889 11.9583H21.7855C22.5526 11.9583 23.1745 12.5802 23.1745 13.3473V13.8682C23.1745 14.1079 22.9802 14.3022 22.7404 14.3022Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6793 2.71113C21.6793 3.47825 21.0575 4.1001 20.2903 4.1001C19.5232 4.1001 18.9014 3.47825 18.9014 2.71113C18.9014 1.94401 19.5232 1.32217 20.2903 1.32217C21.0575 1.32217 21.6793 1.94401 21.6793 2.71113Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0426 6.44434H22.244C22.4838 6.44434 22.678 6.25012 22.678 6.01035V5.48957C22.678 4.72215 22.0562 4.10039 21.2888 4.10039H19.2925C18.5251 4.10039 17.9033 4.72215 17.9033 5.48957V6.01035C17.9033 6.25012 18.0975 6.44434 18.3373 6.44434H21.0426Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6777,
    y: 7.22729,
    width: 1.4,
    height: 5.11246,
    rx: 0.7,
    transform: "rotate(46 13.6777 7.22729)",
    fill: "#6F767E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1323,
    y: 10.4922,
    width: 1.4,
    height: 2.96435,
    rx: 0.7,
    transform: "rotate(46 14.1323 10.4922)",
    fill: "#6F767E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12003_3400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.6118125c737b31210860191c1dce9044.svg";
export { ForwardRef as ReactComponent };